export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8067.aff7a803.jpg";